export const environment = {
  production: false,
  appVersion: require('../../package.json').version + '-prod',
  version: require('../../package.json').version,
  blobUrl: 'https://lumprodsta.blob.core.windows.net/prodcontainer',
  apiUrl: 'https://prodapi.luminousindia.com/customer/api/',
  apiDomain: 'prodapi.luminousindia.com',
  emailForRoutes: 'jO6h51tEHyOfOom9E46YJwUj1yixET/JAHA9WVUSr8w=',
  passwordForRoutes: 'FAqpaioFtYP9P+ZpmkgRDCLjXFg0SSkgyWdU9JIotFI=',
  pathForRoutes: '/customer/api/CustomerConsultation/GetRedirectUrlAsync',
  encryptSecretKey: "Do7wF66aPjqa6i7u",
  ivKey: "Ln_Zn-zm7E9u@&TF",
  googleProvider: '897103566013-m9o4bff2vj2r9jp76mdnmcrhpu0u822n.apps.googleusercontent.com',
  facebookProvider: '1793043107653144',
  accessCode: 'AVQR75FA88CK38RQKC',
  actionLink: 'https://secure.ccavenue.com/transaction/transaction.do?command=initiateTransaction',
  baseUrl: 'https://www.luminousindia.com/',
  baseApiURl: 'https://www.luminousindia.com',
  webUrlForDistributor: 'https://distributor.luminousindia.com/',
  snapmintUrl: "https://api.snapmint.com/v3/public/online_checkout",
  merchantId:2663,
  merchantIdB:4791,
};
